import React from 'react';
import BreakdownRingChart from '../../../../../../../shared/designSystem/components/BreakdownRingChart';

// LineItemsDonut — thin adapter for the shared BreakdownRingChart.
//
// Line items only surface 'impressions' / 'clicks' dimensions (no CTR).
// BreakdownRingChart accepts those verbatim, so this wrapper just forwards.
const LineItemsDonut = ({ data, height, selectedDimension = 'impressions' }) => (
  <BreakdownRingChart
    data={data}
    dimension={selectedDimension}
    height={height}
  />
);

export default LineItemsDonut;
